import React, { useEffect, useState } from 'react';
import {
  Navbar,
  NavbarBrand,
  Nav,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
  Row,
  Button,
  Col,
Modal,
ModalBody
} from 'reactstrap';
import Tooltip from 'react-bootstrap/Tooltip';

import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { isEmpty } from 'lodash';
import Logo from 'components/Logo';
import poweredBy from 'assets/images/powered_by_pharmaforce.svg';
import useOidc from 'hooks/useOidc';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import hospital from '../assets/images/hospital.svg'
import AiImage from '../assets/images/chatbot-icon1.svg';
import { faBuildingColumns, faBell, faUser, faQuestion } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import contract from '../assets/Images/ContractPharmacyUserGuide.pdf'

import user from "assets/icon/user-icon.svg";
import notification from "assets/icon/notification-icon.svg";
import organizations from "assets/icon/organizations-icon.svg";
import Search from "assets/icon/Search-Icon-primary.svg";

import Export from "assets/icon/ExportDownload.svg";
import ExportPending from "assets/icon/ExportPending.svg";
import DownLoadingPending from "assets/icon/ExportDownloads.svg";
import DownLoadingCompleted from "assets/icon/ExportDownloadComplete.svg";
import ExportCancel from "assets/icon/ExportCancelIcon.svg";
//import useSignalr from "hooks/useSignalr";
import useSignalr from 'hooks/useSignalr';
import moment from "moment";
import Loader from 'components/Loader';
import PDF from "assets/images/SplitBillingFullUserGuide.pdf"
import ChatBotPage from '../containers/ChatBot';

const Header = (props) => {
  const [orgData, setOrgData] = useState([]);
  const { onOrgChange, isRendered,
    isTogglingPosition,
    setIsRendered,
    setIsTogglingPosition,
    onClick,
    showChatboat,
    showchat,
    setShowChat,
    setChatbotOpen,
    chatbotOpen,
    addClass,
    setAddClass,
    handelSubmit,
    setShowSearch,
    showSearch,
    sideExpand,
    setSideExpand } = props;


  const { logout } = useOidc();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [hidePoweredBy, setHidePoweredBy] = useState(false);
  const [selectedOrg, setSelectedOrg] = useState({});
  const [userName, setUserName] = useState('');
  const [userId, setUserId] = useState('');
  const navigate = useNavigate();

  const [selectedOrgInput, setSelectedOrgInput] = useState(null);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [modal, setModal] = useState(false);
  const [downloadHistory, setDownloadHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setOpen] = useState(false);


  const signalR = useSignalr();
  (signalR, "in header");


  useEffect(() => {
    if (signalR.count >= 1) {
      setIsLoading(true);

      // if (signalR && signalR.messages && signalR.messages.length > 0) {
      // }
    } else {
      setIsLoading(false);
    }
  }, [signalR.messages, signalR.count, isLoading]);
  useEffect(() => {
    if (signalR.messages.length !== 0) {
      setDropdownOpen(true);
    }
    if (signalR.count == 1) {
      setDropdownOpen(true);
    }
  }, [signalR.messages, signalR.count]);

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  useEffect(() => {

    const { token_type, access_token, profile } =
      JSON.parse(localStorage.getItem('pharmaforce')) || {};
    const { username } = profile || {};
    const { sub } = profile || {};
    setUserName(username);
    setUserId(sub);



    const interval = setInterval(() => { }, 1000);

    const theme = localStorage.getItem('theme') || "PF";

    if (theme === "PF") setHidePoweredBy(true);

    if (!access_token) {
      navigate('/');
    }
    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    fetchOrganization(null);
  }, [])

 useEffect(() => {
  if (!selectedOrgInput || selectedOrgInput.length === 0) {
    fetchOrganization(null);
  }
}, [selectedOrgInput]);


  const fetchOrganization = async (term) => {
    const { token_type, access_token, profile } =
      JSON.parse(localStorage.getItem('pharmaforce')) || {};
    const { sub } = profile || {};
    // setLoading(true)
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_ENDPOINT}/SBConfig/coveredentity/orglist/${term}`,
        {
          params: { Id: sub },
          headers: {
            'Content-type': 'application/json',
            Authorization: `${token_type} ${access_token}`,
           
          },
        }
      );
 console.log(data,"datademo")
      // console.log(data,"data")
      let val = data;
      if (Array.isArray(val)) {
         setOrgData(val);
         if(val.length===1){
          setSelectedOrg(val[0])
         onOrgChange(val[0]);
         window.selectedOrganizationId = val[0];
         setLoading(false)
         }
        // let value = val[0];
        // setSelectedOrg(value)
        // onOrgChange(value);
        // window.selectedOrganizationId = value;
        // setLoading(false)
      }
      else {
        setSelectedOrg(val);
        onOrgChange(val);
        window.selectedOrganizationId = val;
        // setLoading(false)

      }

    }
    catch (error) {
      console.log(error.message);
      // setLoading(false)

    }



    return (
      <>
      </>
    )
  }


  const handleLogout = () => {
    localStorage.clear();
    logout();
  };

  const handelToggle = () => {
    setLoading(true);
    getDownloadHistory();
    setOpen(!isOpen);
  };

  const getDownloadHistory = async () => {
    //
    setLoading(true);

    const { token_type, access_token, profile } =
      JSON.parse(localStorage.getItem("pharmaforce")) || {};
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_MESSAGE_ENDPOINT}/api/Download/DownloadHistory/SBClientUI`,
        {
          //params: { Id: sub },
          headers: {
            "Content-type": "application/json",
            Authorization: `${token_type} ${access_token}`,
          },
        }
      );
      setLoading(true);

      if (data) {
        setOpen(!isOpen);
        data.map((item, index) => {
          if (Array.isArray(item.dataExportMessages)) {
            item.dataExportMessages.map((item1, index) => {
              item1.gridCode = AppModuleName(item1.gridCode);
            });
          }
        });
        setDownloadHistory(data);
        setLoading(false);
      }
    } catch (ex) { }
  };
  const hadleOrgChange = (e) => {
    
    var val = e.target.value;
    if (val.length > 2) {
      fetchOrganization(val);
      setSelectedOrgInput(val);
    } else if (val == null || val == "") {
      fetchOrganization(null);
      setSelectedOrgInput(null);
    } else {
      setSelectedOrgInput(val);
        window.selectedCoveredEntittyId = [];
    }
  };


  const handleOrgChange = (org) => {
    setSelectedOrg(org);
    onOrgChange(org);
    window.selectedOrganizationId = org.organizationID;
    window.selectedCoveredEntittyId = [];
  };

  const AppModuleName = (gridCode) => {
    let moduleName = "";
    if (gridCode.indexOf("rxmanager") !== -1) {
      moduleName = "Rx Manager";
    } else if (gridCode.indexOf("accumulation") !== -1) {
      moduleName = "Accumulations";
    } else if (gridCode.indexOf("purchaseorder") !== -1) {
      moduleName = "Purchase Order";
    } else if (gridCode.indexOf("inventory") !== -1) {
      moduleName = "Inventory";
    } else if (gridCode.indexOf("configuration") !== -1) {
      moduleName = "Configuration";
    } else if (gridCode.indexOf("drug") !== -1) {
      moduleName = "Drug Catalog";
    } else if (gridCode.indexOf("prescriber") !== -1) {
      moduleName = "Prescriber";
    } else if (gridCode.indexOf("invoice") !== -1) {
      moduleName = "Invoice";
    } else if (gridCode.indexOf("audit") !== -1) {
      moduleName = "Audit";
    } else if (gridCode.indexOf("cereport") !== -1) {
      moduleName = "CE Report";
    } else if (gridCode.indexOf("patient") !== -1) {
      moduleName = "Patient";
    } else if (gridCode.indexOf("payor") !== -1) {
      moduleName = "Payor";
    }
    return moduleName;
  };

  const download = async (dataExportId) => {
    const { access_token } =
      JSON.parse(localStorage.getItem("pharmaforce")) || {};
    window.open(
      `${process.env.REACT_APP_MESSAGE_ENDPOINT}/api/Download/Download/${dataExportId}?access_token=${access_token}`
    );
  };
  (downloadHistory, "downlaod");
  const handleDownload = () => {
    const fileUrl = PDF;  
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = PDF;
    link.click();
  };

  return (
    <>
      <input type="hidden" value={userId} id="hdnUserId" />
      <Navbar color='white' light className='app-header'>
        <div className='d-flex align-items-center'>
          <NavbarBrand href='/' className='me-0'>
            <Logo height={50} />
          </NavbarBrand>
          <h2 className="ps-3 ms-3 text-primary d-inline mx-1 mt-1 mb-0 top_hed">
            Split Billing 3.0
          </h2>
          {/* <h6 className='text-primary d-inline mx-1 mt-3 mb-0 f-14 raleway-500'>
            3.0
          </h6> */}
        </div>
        <div className='ms-auto powered-by'>
          <img src={poweredBy} title='' alt='' hidden={hidePoweredBy} />
        </div>
        <Nav className='nav_info'>
          {(
            <uncontrolledDropdown nav>
                <ChatBotPage
                  showchat={showchat}
                  setShowChat={setShowChat}
                  isRendered={isRendered}
                  isTogglingPosition={isTogglingPosition}
                  setIsRendered={setIsRendered}
                  setIsTogglingPosition={setIsTogglingPosition}
                  onClick={onClick}
                  setChatbotOpen={setChatbotOpen}
                  chatbotOpen={chatbotOpen}
                  addClass={addClass}
                  setAddClass={setAddClass}
                  handelSubmit={handelSubmit}
                  setShowSearch={setShowSearch}
                  showSearch={showSearch}
                  sideExpand={sideExpand}
                  setSideExpand={setSideExpand}
                  showChatboat={showChatboat}
                  selectedOrg={selectedOrg}
                  orgData={orgData}
                />
              </uncontrolledDropdown>
          )}
          {(

            <UncontrolledDropdown nav className='profile-dropdown'>
              <DropdownToggle nav className='font-weight-500'onClick={() => setSelectedOrgInput("") }>
                <OverlayTrigger
                  overlay={(props) => (
                    <Tooltip {...props}>
                      Organizations
                    </Tooltip>
                  )}
                  placement="bottom"
                >
                  {/* <FontAwesomeIcon icon={faBuildingColumns} className="fa-fw text-dark topicons" style={{ width: '25px', height: '25px' }} /> */}
                  {/* <img src={hospital} className="aiIcon topicons" alt="ai" style={{ width: '45px', height: '45px' }} /> */}
                  <img src={organizations} alt="" />
                </OverlayTrigger>
              </DropdownToggle>

              {/* {orgData.length > 0 ?  */}
              <DropdownMenu className='shadow'>
                <div className="p-2">
                  <div className="has-search">
                    <span className="form-control-feedback">
                      {" "}
                      <img src={Search} />
                    </span>
                    <Input
                      type="text"
                      className="organization-input"
                    value={selectedOrgInput}
                    onChange={(e) => hadleOrgChange(e)}
                    />
                  </div>
                  <div className='org-scroll'>
                    {orgData.length > 0 && orgData.map((org, index) => (
                      <div className="org-name mt-1">
                        <DropdownItem key={org.organizationID} onClick={() => handleOrgChange(org)} className={selectedOrg.organizationCode == org.organizationCode ? 'active' : ''}>
                          <p className="orgname">
                            {org.organizationName}
                          </p>
                        </DropdownItem>
                      </div>
                    ))}
                  </div>
                </div>

              </DropdownMenu>
               {/* : null} */}
            </UncontrolledDropdown>
          )}

          {/* <a href='https://prechat.thepharmaforce.com/' target='_blank' className="btn shadow-none">
          <OverlayTrigger
            overlay={(props) => (
              <Tooltip {...props}>
                AI chatbot
              </Tooltip>
            )}
            placement="bottom"
          >
                      <img src={AiImage} className="aiIcon topicons" alt="ai" style={{ width: '45px', height: '45px' }} />

          </OverlayTrigger>

        </a> */}
          {/* <a href={"#"} without rel='noopener noreferrer' target='_blank' className="btn shadow-none" style={{ marginLeft: '0px' }}>
          <OverlayTrigger
            overlay={(props) => (
              <Tooltip {...props}>
                User Guide
              </Tooltip>
            )}
            placement="bottom"
          >
                      <FontAwesomeIcon icon={faQuestion} className="fa-fw topicons" style={{ width: '25px', height: '25px' }} />

          </OverlayTrigger>

        </a > */}

          <UncontrolledDropdown className="profile-dropdown" onClick={()=>{window.open("https://app.getbeamer.com/pharmaforce-split-billing/en", "_blank");
}} href='https://app.getbeamer.com/pharmaforce-split-billing/en' target='_blank' nav >
            <DropdownToggle
              nav
              className=""
              style={{ position: "relative" }}
            >
              <OverlayTrigger
                overlay={(props) => (
                  <Tooltip {...props}>
                    Notification Center
                  </Tooltip>
                )}
                placement="bottom"
              >
                {/* <FontAwesomeIcon icon={faBell} className="fa-fw topicons" style={{ width: '25px', height: '25px' }} /> */}
                <img src={notification} alt="" />
              </OverlayTrigger>
              <span id="spnNotificationCnt" className="notifcnt">1</span>
            </DropdownToggle>
          </UncontrolledDropdown>

          {/* <a href='https://app.getbeamer.com/pharmaforce/en' target='_blank' className="btn shadow-none mr-0" style={{ marginLeft: '0px' }}></a> */}

          {/* {!loading && (
            <Nav className='ps-4'>
              <UncontrolledDropdown nav className='profile-dropdown'>
                <DropdownToggle nav caret className='font-weight-500'>
                  {!isEmpty(data) ? data.firstName + ' ' + data.lastName : ''}
                </DropdownToggle>
                <DropdownMenu className='shadow'>
                  <DropdownItem onClick={handleLogout}>Logout</DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>
          )} */}
           <UncontrolledDropdown
          nav
                className="profile-dropdown"
                isOpen={dropdownOpen}
                toggle={toggleDropdown}>
            
                <DropdownToggle
                  nav
                  className=""
                  style={{ position: "relative" }}
                >


                <OverlayTrigger
                    overlay={(props) => (
                      <Tooltip {...props}>Export Notifications</Tooltip>
                    )}
                    placement="bottom"
                  >
                  {isLoading ? (
                      <div className="spinner-container">
                        {/* <Spinner
                          animation="border"
                          size="sm"
                          className="spinner-overlay"
                        /> */}
                        <img
                          src={Export}
                          alt="Export"
                          className="export-image"
                        />
                      </div>
                    ) : (
                      <img src={Export} alt="Export" className="export-image" />
                    )}
                  </OverlayTrigger>
                  </DropdownToggle>

                  <DropdownMenu className="shadow export">
                  <DropdownItem>
                  <div>
                      <div
                        className="d-flex justify-content-between "
                        style={{ borderBottom: "1px solid #D3D3D3" }}
                      >
                        <span
                          className="f-12"
                          style={{ fontWeight: 500, color: "#757575" }}
                        >
                          Export Notifications
                        </span>
                        <div>
                          <a
                            onClick={(event) => {
                              // handleDownloadHistory(event);
                              handelToggle();
                            }}
                            className="text-primary f-12 font-weight-600"
                            style={{ color: "" }}
                          >
                            View All
                          </a>
                        </div>
                      </div>
                      <>
                        {signalR.count == 1 && (
                          <div>
                            <div className="d-flex mt-2">
                              <img src={ExportPending} />
                              <div className="f-16 font-weight-400 ms-2 word-wrap">
                                <div className="text-left">
                                  {" "}
                                  Downloading is in progress. We will notify you when it is complete.
                                </div>
                              </div>
                            </div>

                            {/* <div className="">
                              <Button
                                color="primary"
                                className="export-pending mt-2 w-100"
                              >
                                {" "}
                                <span className="right_5">
                                  <img src={DownLoadingPending} alt="" />
                                </span>{" "}
                                Downlaod
                              </Button>
                            </div> */}
                          </div>
                        )}
                      </>
                      <>
                        {signalR.count != 1 && signalR.messages.length !== 0 && (
                          <div>
                            <div className="mt-2">
                              <div className=" d-flex justify-content-between ms-2">
                                <div>
                                  <div className="f-16 font-weight-600 text-primary">
                                    {signalR.messages.fileName}
                                  </div>
                                  <div
                                    className="f-12 font-weight-500"
                                    style={{ color: "#757575" }}
                                  >
                                    {AppModuleName(signalR.messages.gridCode)}
                                  </div>
                                </div>
                                <div
                                  className=" d-flex justify-content-end w-100 h-auto"
                                  style={{
                                    overflow: "auto",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  <div
                                    className="f-12 font-weight-500"
                                    style={{
                                      color: "#757575",
                                    }}
                                  >
                                    <p
                                      style={{
                                        whiteSpace: "pre-wrap",
                                        marginBottom: "0px",
                                      }}
                                    >
                                      {moment(
                                        new Date(
                                          signalR.messages.fileGeneatedDate
                                        )
                                      ).format("MM/DD/YYYY")}
                                    </p>
                                    <p
                                      style={{
                                        whiteSpace: "pre-wrap",
                                        marginBottom: "0px",
                                      }}
                                    >
                                      {moment(
                                        new Date(
                                          signalR.messages.fileGeneatedDate
                                        )
                                      ).format("hh:mm A")}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="">
                              <Button
                                color="primary"
                                className="search mt-2 w-100"
                                onClick={() =>
                                  download(signalR.messages.dataExportID)
                                }
                              >
                                <span className="right_5">
                                  <img src={DownLoadingCompleted} alt="" />
                                </span>{""}
                                Download
                              </Button>
                            </div>
                          </div>
                        )}
                      </>
                    </div>


                  </DropdownItem>
                  </DropdownMenu>

          </UncontrolledDropdown>
          {(

            <UncontrolledDropdown nav className='profile-dropdown'>
              <DropdownToggle nav className='font-weight-500'>
                <OverlayTrigger
                  overlay={(props) => (
                    <Tooltip {...props}>
                      View Profile
                    </Tooltip>
                  )}
                  placement="bottom"
                >
                  {/* <FontAwesomeIcon icon={faUser} className="fa-fw text-dark topicons" style={{ width: '25px', height: '25px' }} /> */}
                  <img src={user} alt="" />
                </OverlayTrigger>
              </DropdownToggle>
              <DropdownMenu className="shadow">
                <DropdownItem >
                  <div id="app">
                    <div className="text-end">
                      <div className="text-start" 
                      // style={{ marginLeft: "0px", zIndex: 9 }}
                      >
                        <div className="">
                          <div id="circle-avatar" className="text-center mx-auto mb-4 h3"

                          // style={
                          //   // {backgroundColor:"yellow", borderRadius:"60%"}
                          //   }
                          >
                            {userName[0]}
                          </div>

                          <h5 className="text-center" 
                           style={{ whiteSpace: "normal" }}
                           >{userName}</h5>
                          {/* <p className="text-center mb-2">jd@gmail.com</p> */}

                          {/* <hr /> */}

                          {/* <hr className="mb-0" style={{ margin: "0 -24px 0" }} /> */}

                          <div
                            className="list-group list-group-flush"
                            // style={{ margin: "0 -24px 0" }}
                          >
                            <button className="list-group-item list-group-item-action" hidden={true}>
                              <small>Change Requests</small>
                            </button>
                            <button className="list-group-item list-group-item-action" onClick={handleDownload}>
                              <small>User Guide</small>
                            </button>
                            <button className="list-group-item list-group-item-action" hidden={true}>
                              <small>Pending Requests</small>
                            </button>
                            <button className="list-group-item list-group-item-action" hidden={true}>
                              <small>Other Requests</small>
                            </button>
                          </div>

                          {/* <hr style={{ margin: "0 -24px 24px" }} /> */}

                          <div className="d-grid">
                            <button className="btn btn-secondary" onClick={handleLogout} >
                              <small>Logout</small>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>

          )}
         

                         
        </Nav>
        <Modal
          isOpen={isOpen}
          toggle={handelToggle}
          size="lg"
          className="lg "
        >
          <ModalBody className="m-2 p-4">
            <div className="d-flex justify-content-between">
              <h6 className="f-24 ">All Exports</h6>
              <div onClick={handelToggle}>
                <img src={ExportCancel} />
              </div>
            </div>
            {loading == true ? (
              <Loader opacity={0.01} color="black" />
            ) : (
              <div className="export-modal">
                {downloadHistory.map((item, index) => (
                  <Row className="mt-3  ">
                    <h6
                      className="f-14 font-size-600"
                      style={{ color: "#757575" }}
                    >
                      {item.displayHeader}
                    </h6>
                    <hr></hr>
                    {item.dataExportMessages.map((item1, index) => (
                      <Col md={6} className="mt-2">
                        <div
                          className="p-2"
                          style={{
                            border: "1px solid #D3D3D3",
                            borderRadius: "4px",
                            minHeight: "100px",
                          }}
                        >
                          <div
                            className=" d-flex justify-content-between align-items-center"
                            style={{
                              wordBreak: "break-word",
                              whiteSpace: "normal",
                            }}
                          >
                            <div className="f-14 font-weight-600 text-primary">
                              {item1.fileName}
                            </div>
                            <div
                              className="f-12 font-weight-500"
                              style={{ color: "#757575" }}
                            >
                              {moment(new Date(item1.fileGeneatedDate)).format(
                                "MM/DD/YYYY hh:mm A"
                              )}
                            </div>
                          </div>
                          <div
                            className=" d-flex justify-content-between  mt-2"
                            style={{
                              alignItems: "flex-end",
                            }}
                          >
                            <div
                              className="f-12 font-weight-500"
                              style={{
                                color: "#757575",
                              }}
                            >
                              {item1.gridCode}
                            </div>
                            {/* <div className="">
                              <Button
                                color="primary"
                                className="search-downlaod"
                                onClick={() => download(item1.dataExportID)}
                              >
                                {" "}
                                <span className="right_5">
                                  <img src={DownLoadingPending} alt="" />
                                </span>{" "}
                                Download
                              </Button>
                            </div> */}
                            {item1.exportStatusID == 1 ? (
                              <div className="">
                                <Button
                                  color="primary"
                                  className="search"
                                  onClick={() => download(item1.dataExportID)}
                                >
                                  {" "}
                                  <div className="spinner-container1">

                                  </div>

                                  {"  "}  In Progress
                                </Button>
                              </div>
                            ) : (
                              <div className="">
                                <Button
                                  color="primary"
                                  className="search-downlaod"
                                  onClick={() => download(item1.dataExportID)}
                                >
                                  {" "}
                                  <span className="right_5">
                                    <img src={DownLoadingPending} alt="" />
                                  </span>{" "}
                                  Download
                                </Button>
                              </div>
                            )}

                          </div>
                        </div>
                      </Col>
                    ))}
                  </Row>
                ))}
              </div>
            )}

            {/* {
                downloadHistory.map((item, index) => (
                  <Col md={6}>
                    <div
                      className="p-2"
                      style={{ border: "1px solid #D3D3D3", borderRadius: "4px" }}
                    >
                      <div className=" d-flex justify-content-between align-items-center">
                        <div className="f-16 font-weight-600 text-primary">
                          {item.fileName}
                        </div>
                        <div
                          className="f-12 font-weight-500"
                          style={{ color: "#757575" }}
                        >
                          {moment(new Date(item.fileGeneatedDate)).format("MM/DD/YYYY hh:mm A")}
                        </div>
                      </div>
                      <div
                        className=" d-flex justify-content-between align-items-center"
                      // style={{
                      //   overflow: "auto", // Corrected the typo here
                      //   wordWrap: "break-word",
                      // }}
                      >
                        <div
                          className="f-12 font-weight-500"
                          style={{
                            color: "#757575",
                          }}
                        >
                          {item.gridCode}
                        </div>
                        <div className="">
                          <Button color="primary" className="search " onClick={() => download(item.dataExportID)}>
                            {" "}
                            <span className="right_5">
                              <img src={DownLoadingPending} alt="" />
                            </span>{" "}
                            Download
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))
              } */}
          </ModalBody>
        </Modal>
      </Navbar>
    </>
  );
};

export default Header;
